import { useEffect } from 'react';

export function useSingleOptionAutoSelect<T>(
  options: T[],
  currentValue: string,
  onChange: (value: string) => void,
  disabled: boolean = false,
  getValue: (option: T) => string = (option: T) =>
    (option as unknown as { value: string }).value
) {
  useEffect(() => {
    if (options.length === 1) {
      const singleOptionValue = getValue(options[0]);
      if (currentValue !== singleOptionValue) {
        onChange(singleOptionValue);
      }
    }
  }, [options, currentValue, onChange, getValue]);

  return {
    isDisabled: options.length === 0 || options.length === 1 || disabled,
    isSingleOption: options.length === 1,
  };
}
